import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  Icon,
  Header,
  Form,
  Loader,
} from 'semantic-ui-react';
import {
  DatesRangeInput
} from 'semantic-ui-calendar-react-17';
import { reportActions } from '../../actions/report.actions';
import PropTypes from 'prop-types';
import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";
import 'moment/locale/pt-br';
import { PaginationContainer } from '../../components/PaginationContainer';
import _ from 'lodash';

const DATE_FORMAT = "DD/MM/YYYY";
const FILTER_FORMAT = "YYYY-MM-DD";

class RequestPerUserReportScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
        page: 1,
        approver: null,
        department: null,
        period: ''
    };
  }

  static get propTypes() {
    return {
       registers: PropTypes.any,
       loading: PropTypes.bool,
    };
  }

  componentDidMount() {
    this.handleSearchDebounced = _.debounce(function() {
      this.fetchRegisters();
    }, 500);
    const monthStart = moment().startOf('month').format(DATE_FORMAT);
    const today = moment().format(DATE_FORMAT);
    this.setState({ period: `${monthStart} - ${today}`}, () => this.fetchRegisters());
  }

  handlePageChange(activePage) {
      this.setState({ page: activePage }, () => this.fetchRegisters());
  }

  handlePeriodChange(period) {
    this.setState({ period }, () => this.fetchRegisters());
  }

  handleApproverChange(approver) {
    this.setState({ approver, page: 1 });
    this.handleSearchDebounced();
  }

  handleDepartmentChange(department) {
    this.setState({ department, page: 1 });
    this.handleSearchDebounced();
  }

  fetchRegisters(isExport) {
    const { dispatch } = this.props;
    const { page, approver, department, period } = this.state;

    var [startDate, endDate] = period.split(' - ');
    if (startDate) {
      startDate = moment(startDate, DATE_FORMAT).format(FILTER_FORMAT);
    }

    if (endDate) {
      endDate = moment(endDate, DATE_FORMAT).format(FILTER_FORMAT);
    }

    dispatch(reportActions.fetchRequestsPerManager({ page, approver, department, startDate, endDate, orderBy: "Id", export: isExport ? true : null, ascending: false }));
  }

  exportXlsx() {
    this.fetchRegisters(true);
  }

  render() {
    const { registers, loading } = this.props;
    const { period } = this.state;
    var rows = [];
    if (registers && registers.Results && registers.Results.length > 0) {
        const users = { };
        registers.Results.forEach((item) => {
            if (item.Status === 1 || item.Status === 4) {
                return;
            }

            if (!users[item.Requester.Id]) {
                users[item.Requester.Id] = {
                    id: item.Requester.Id,
                    name: item.Requester.Name,
                    email: item.Requester.Email,
                    department: item.Requester.Department,
                    total: 0,
                    approved: 0,
                    rejected: 0,
                    approvedTime: 0,
                }
            }

            users[item.Requester.Id].total += 1;
            if (item.Status == 2) {
                users[item.Requester.Id].approved += 1;
                users[item.Requester.Id].approvedTime += item.MinutesAmount;
            } else {
                users[item.Requester.Id].rejected += 1;
            }
        });
        
        rows = Object.values(users);
    }

    return (
      <Fragment>
        <Header>
          <h1>Solicitações por Usuário</h1>
        </Header>
        <Loader active={loading} />
        <Form>
          <Form.Group widths={4}>
            <DatesRangeInput
              name="period"
              localization="pt-br"
              placeholder="Período"
              value={period}
              iconPosition="left"
              dateFormat={DATE_FORMAT}
              label='Data'
              closable={true}
              clearable={true}
              onChange={(e, data) => this.handlePeriodChange(data.value)}
            />
            <Form.Input icon='search' label='Usuário' onChange={(e, data) => this.handleApproverChange(data.value)} loading={loading} />
            <Form.Input icon='search' label='Departamento' onChange={(e, data) => this.handleDepartmentChange(data.value)} loading={loading} />
          </Form.Group>
        </Form>

        {rows && rows.length > 0 &&
          <Table compact>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Usuário</Table.HeaderCell>
                    <Table.HeaderCell>E-Mail</Table.HeaderCell>
                    <Table.HeaderCell>Departamento</Table.HeaderCell>
                    <Table.HeaderCell>Total Solicitações</Table.HeaderCell>
                    <Table.HeaderCell>Aprovadas</Table.HeaderCell>
                    <Table.HeaderCell>Rejeitadas</Table.HeaderCell>                    
                    <Table.HeaderCell>Horas Aprovadas</Table.HeaderCell>                    
                </Table.Row>
            </Table.Header>
            <Table.Body>
                { rows && rows.map((register) => {
                    return <Table.Row key={register.id}>                        
                        <Table.Cell>{register.name}</Table.Cell>
                        <Table.Cell>{register.email}</Table.Cell>
                        <Table.Cell>{register.department}</Table.Cell>
                        <Table.Cell>{register.total}</Table.Cell>
                        <Table.Cell>{register.approved}</Table.Cell>
                        <Table.Cell>{register.rejected}</Table.Cell>
                        <Table.Cell>{moment.duration(register.approvedTime, "minutes").format("HH:mm", { trim: false })}</Table.Cell>
                    </Table.Row>;
                }) }
            </Table.Body>
        </Table>}
        <PaginationContainer registers={registers} onPageChange={(e, { activePage }) => this.handlePageChange(activePage)} />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { report } = state;    
  return {
     registers: report.integrationLogs || null,
     loading: report.loading
  };
}

const connectedReportScreen = connect(mapStateToProps)(RequestPerUserReportScreen);
export { connectedReportScreen as RequestPerUserReportScreen };
